/**
 * Modèle PlayerEvent - Identique à Flutter
 */

export interface PlayerEvent {
  type: string; // Flutter utilise 'type', pas 'typeName'
  attribute?: string;
  value?: string;
  [key: string]: any; // Pour les champs spécifiques au type
}

export const PlayerEventFromJson = (json: any): PlayerEvent => {
  if (!json || typeof json.type !== 'string') {
    throw new Error('Invalid PlayerEvent JSON: missing type');
  }

  return {
    type: json.type,
    attribute: json.attribute,
    value: json.value,
    ...json, // Conserver tous les autres champs
  };
};
